import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import api from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";

const AdminDownloads = () => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/downloads?limit=100")
      .then((r) => { setItems(r.data.items); setTotal(r.data.total); })
      .catch((e) => toast.error("Failed", { description: e.response?.data?.detail || "" }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout title="Download history">
      <div className="border border-border bg-card">
        <div className="hidden md:grid grid-cols-[1fr_1fr_140px_100px] gap-3 items-center px-4 py-3 border-b border-border bg-background text-[11px] uppercase tracking-widest text-muted-foreground">
          <div>Plan</div><div>Downloaded by</div><div>When</div><div>IP</div>
        </div>
        {loading && <div className="p-8 text-center text-muted-foreground text-sm">Loading…</div>}
        {!loading && items.length === 0 && <div className="p-12 text-center text-sm text-muted-foreground" data-testid="downloads-empty">No downloads recorded yet.</div>}
        {!loading && items.map((d) => (
          <div key={d.id} data-testid={`download-row-${d.id}`} className="grid grid-cols-1 md:grid-cols-[1fr_1fr_140px_100px] gap-3 items-center px-4 py-3 border-b border-border last:border-b-0 hover:bg-background/60">
            <Link to={`/admin/plans/${d.plan_id}/edit`} className="text-sm truncate hover:text-accent">{d.plan_title}</Link>
            <div className="text-sm truncate">{d.user_email || d.user_id}</div>
            <div className="text-xs">{d.downloaded_at ? new Date(d.downloaded_at).toLocaleString() : "—"}</div>
            <div className="text-xs text-muted-foreground">{d.ip || "—"}</div>
          </div>
        ))}
      </div>
      <div className="text-xs text-muted-foreground mt-3">{total} download(s)</div>
    </AdminLayout>
  );
};

export default AdminDownloads;
